import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { StyledUsePointsDiv } from '../usePoints/usePoints.styles';
import { baseVariables } from '@marriott/mi-ui-library';

export const SearchDesktopSecondary = styled.div`
  ${rtl`
  margin: 0;
  display: flex;
  background-color: ${theme.color.white};
  align-items: center;
  justify-content: flex-start;
  border-radius: 0 0 ${toRem(14)} ${toRem(14)};
  &.show-search-bar-on-edit {
    display: flex !important;
  }
  &.search-bar {
    .search__use-points {
      @media  ${baseVariables.mediaQuery.allTablets} {
        label {
          width: ${toRem(230)};
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    ${StyledUsePointsDiv} {
      label {
        margin-bottom: 0;
      }
    }
    ${StyledUsePointsDiv} {
      margin-top: ${toRem(16)};
      padding-bottom: ${toRem(17)};
      padding-left: ${toRem(18)};
      white-space: nowrap;
    }
    input[type='checkbox']:focus + label:before {
      outline: ${toRem(1)} auto ${theme.color['black']} !important;
    }
  }
  &.adf-search-bar{
    @media ${theme.mediaQuery.tablet}{
    margin:auto;
    }
    ${StyledUsePointsDiv} {
      margin-top: 0;
      padding-bottom:${toRem(20)};
    }
  }
  &.adf-search-bar{
    @media ${theme.mediaQuery.tablet} {
    margin-top: 0 !important;
    }
  }
 
  margin-top: -${toRem(14)};

  @media ${theme.mediaQuery.tablet} {
    padding-top: ${toRem(14)} !important;
  }
  @media ${theme.mediaQuery.desktop} {
    padding-top: ${toRem(14)} !important;
    padding-left: ${toRem(4)} !important;
  }

  > div {
    margin-right: ${toRem(20)};
    > button {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
      span {
        margin-left: ${toRem(10)};
      }
    }
    padding: ${toRem(16)} ${toRem(24)} ${toRem(13.5)};
    @media ${theme.mediaQuery.tablet} {
      padding: ${toRem(16)} ${toRem(24)} ${toRem(18)} ${toRem(24)};
    }
    @media ${theme.mediaQuery.desktop} {
      padding: ${toRem(16)} ${toRem(20)} ${toRem(18)} ${toRem(36)};
    }
  }
  input[type='checkbox'] + label {
    top: 0;
    font-family: ${theme.fontFamily.swiss};
  }
   input[type='checkbox'] + label:before {
    outline:none !important;
  }
 input[type=radio]:checked~label:before {
    outline:none !important;
  }

  &.search-secondary {
    box-shadow: 0 ${toRem(2)}  ${toRem(8)}  0 rgb(0 0 0 / 7%);
  }
`}
`;
